// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-group[data-v-40aef354],.image-group .image-slot.error[data-v-40aef354]{display:flex;align-items:center;justify-content:center}.image-group .image-slot.error[data-v-40aef354]{height:100%}.image-group[data-v-40aef354] {display:flex;align-items:center;justify-content:center}.skeleton[data-v-40aef354],.skeleton>*[data-v-40aef354]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.inner-circle[data-v-40aef354]{background-color:#fff;top:2px}", ""]);
// Exports
module.exports = exports;
